
import { Polygon, LineString, MultiLineString, MultiPolygon, Point, MultiPoint } from 'ol/geom'
import Feature from 'ol/Feature.js';

// 定义图形要素类型
const POLYGON = 'Polygon';
const MULTIPOLYGON = 'MultiPolygon';
const LINESTRING = 'LineString';
const MULTILINESTRING = 'MultiLineString';
const POINT = 'Point';
const MULTIPOINT = 'MultiPoint';

/**
 * 将多个面（面或者多秒）合并为多面
 * @param features
 * @returns {MultiPolygon}
 * @constructor
 */
function GeometryToMulti(features, geometryType) {

    if (!features || !features.length || features.length <= 0) {
        return;
    }

    let multiGeometry;

    if (POLYGON.toLowerCase() == geometryType.toLowerCase()) {
        multiGeometry = new MultiPolygon([]);
    } else if (LINESTRING.toLowerCase() == geometryType.toLowerCase()) {
        multiGeometry = new MultiLineString([]);
    } else if (POINT.toLowerCase() == geometryType.toLowerCase()) {
        multiGeometry = new MultiPoint([]);
    }
    
    if (MULTIPOLYGON.toLowerCase() == geometryType.toLowerCase()) {
        multiGeometry = new MultiPolygon([]);
    } else if (MULTILINESTRING.toLowerCase() == geometryType.toLowerCase()) {
        multiGeometry = new MultiLineString([]);
    } else if (MULTIPOINT.toLowerCase() == geometryType.toLowerCase()) {
        multiGeometry = new MultiPoint([]);
    }

    let appendFunc = function (multi, geometries) {
        for (let i = 0; i < geometries.length; i++) {
            switch (multi.getType()) {
                case MULTIPOLYGON:
                    multi.appendPolygon(geometries[i]);
                    break;
                case MULTILINESTRING:
                    multi.appendLinearRing(geometries[i]);
                    break;
                case MULTIPOINT:
                    multi.appendPoint(geometries[i]);
                    break;
            }
        }
    }

    for (let i = 0; i < features.length; i++) {

        let type = features[i].getGeometry().getType();
        let temp = features[i].getGeometry();

        switch (type) {
            case MULTIPOLYGON:
                appendFunc(multiGeometry, temp.getPolygons());
                break;
            case MULTILINESTRING:
                appendFunc(multiGeometry, temp.getLineStrings());
                break;
            case MULTIPOINT:
                appendFunc(multiGeometry, temp.getPoints());
                break;
            case POLYGON:
                multiGeometry.appendPolygon(features[i].getGeometry());
                break;
            case LINESTRING:
                multiGeometry.appendLineString(features[i].getGeometry());
                break;
            case POINT:
                multiGeometry.appendPoint(features[i].getGeometry());
                break;
        }
    }

    return new Feature(multiGeometry);
}

/**
 * 将多面拆分为多个面
 * @param feature
 * @returns {Polygon}
 * @constructor
 */
function MultiToGeometry(feature) {

    if (!feature || !(feature instanceof Feature)) {
        return;
    }

    let temp = feature.getGeometry();

    let type = feature.getGeometry().getType();

    let tempArr;
    if (MULTIPOLYGON == type) {
        tempArr = temp.getPolygons();
    } else if (MULTILINESTRING == type) {
        tempArr = temp.getLineStrings();
    } else if (MULTIPOINT == type) {
        tempArr = temp.getPoints();
    }

    let features;
    if (tempArr && tempArr.length > 0) {
        features = [];
        for (let i = 0; i < tempArr.length; i++) {
            features.push(new Feature(tempArr[i]));
        }
    }
    return features;
}

// // 面转为多面
// function polygonToMulti() {
//     closeFeature();
//     setTimeout(function () {
//         let featureMulti = GeometryToMulti(features, POLYGON);
//         layer.getSource().addFeatures([featureMulti]);
//         console.log(getWKTByFeature(featureMulti));
//         moveTo(layer);
//     }, 350)
// }

// // 多面转为面
// function multiToPolygon() {
//     closeFeature();
//     setTimeout(function () {
//         let featureMulti = MultiToGeometry(featureMultiPolygon);
//         layer.getSource().addFeatures(featureMulti);
//         moveTo(layer);
//         console.log(getWKTByFeature(featureMulti));
//     }, 350)
// }

// // 清空
// function closeFeature() {
//     layer.getSource().clear();
// }

export { GeometryToMulti, MultiToGeometry }